import React from "react"
import {Badge} from "../Badge/Badge"

interface TitleWithBadgeProps {
	title: string
	showBadge?: boolean
	badgeText: string
	heading: "h1" | "h2" | "h3"
	badgeTooltip?: string
	badgeTooltipClassname?: string
	badgeTooltipKey?: string
}
export default function TitleWithBadge({
	title,
	showBadge,
	badgeText,
	heading: Heading,
	badgeTooltip,
	badgeTooltipClassname,
	badgeTooltipKey,
}: TitleWithBadgeProps) {
	return (
		<Heading className="title-with-badge">
			<span className="title-container">{title}</span>
			{showBadge && (
				<Badge
					text={badgeText}
					hasChanges
					className="inline-badge"
					{...(badgeTooltip
						? {
								tooltip: badgeTooltip,
								tooltipPlace: "bottom",
								tooltipMultiline: true,
								tooltipClassname: badgeTooltipClassname,
								tooltipKey: badgeTooltipKey,
						  }
						: {})}
				/>
			)}
		</Heading>
	)
}
